import moment from 'moment-timezone';
import { DAY_AND_TIME_FORMAT, DAY_FORMAT } from '../constants';

export function getStartOfQuarter(startDate: string) {
  const date = moment(startDate, [DAY_FORMAT, DAY_AND_TIME_FORMAT]);
  return date.startOf('quarter').format(DAY_FORMAT);
}

export function getEndOfQuarter(startDate: string) {
  const date = moment(startDate, [DAY_FORMAT, DAY_AND_TIME_FORMAT]);
  return date.endOf('quarter').format(DAY_FORMAT);
}

export function dateFormat(value: string, format: string) {
  const initialValue = moment(value, [DAY_FORMAT, DAY_AND_TIME_FORMAT]);
  return initialValue.format(format);
}
